import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c04ad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Manage Vaults", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Choose vault:", -1))
const _hoisted_5 = { class: "nes-select mb-5" }
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "locked flex-col justify-center items-center align-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "This vault is locked!", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VaultDetails = _resolveComponent("VaultDetails")!
  const _component_NFTGrid = _resolveComponent("NFTGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.fetchedVaultList && _ctx.fetchedVaultList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVault) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchedVaultList, (v) => {
                return (_openBlock(), _createElementBlock("option", {
                  id: v.publicKey.toBase58()
                }, _toDisplayString(v.publicKey.toBase58()), 9, _hoisted_6))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.selectedVault]
            ])
          ]),
          (_ctx.selectedVaultAcc)
            ? (_openBlock(), _createBlock(_component_VaultDetails, {
                class: "mb-5",
                key: _ctx.selectedVaultAcc,
                vaultAcc: _ctx.selectedVaultAcc
              }, null, 8, ["vaultAcc"]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "nes-btn is-primary mb-5",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setVaultLock && _ctx.setVaultLock(...args)))
          }, _toDisplayString(_ctx.parseVaultLock() ? 'Unlock' : 'Lock') + " vault ", 1),
          _createElementVNode("div", null, [
            _createVNode(_component_NFTGrid, {
              class: "nes-container with-title",
              title: "Vault contents",
              nfts: _ctx.fetchedVaultNFTs
            }, {
              default: _withCtx(() => [
                (_ctx.parseVaultLock())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["nfts"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, "This bank has no vaults yet :("))
  ]))
}